import './App.css'
// Design system loads after App.css so the instrument skin wins the cascade
// without needing !important. See src/styles/tokens.css for the direction.
import './styles/tokens.css'
import './styles/primitives.css'
import './styles/calculator-instrument.css'
import './styles/pricing-instrument.css'
import './styles/home-instrument.css'
import './styles/auth-instrument.css'
import './styles/pages-instrument.css'
import './styles/chrome-instrument.css'
import Header from './components/common/Header';
import { BrowserRouter as Router, Routes, Route, json } from 'react-router-dom';
import Footer from './components/common/Footer';
import { AuthProvider } from './provider/AuthProvider';
import { SubscriptionProvider } from './provider/SubscriptionProvider';
import ReactGA from 'react-ga4';
import { useEffect, lazy, Suspense } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { current } from '@reduxjs/toolkit';
import ScrollToTop from './components/common/ScrollToTop';

/* Route components, loaded on demand. Declared together after the imports
   because ESLint requires every import to precede other statements. */
const Home = lazy(() => import('./components/Pages/Home'));
const About = lazy(() => import('./components/Pages/About'));
const Contact = lazy(() => import('./components/Pages/Contact'));
const Pricing = lazy(() => import('./components/Pages/Pricing'));
const Calculator = lazy(() => import('./components/Pages/Calculator'));
const Signup = lazy(() => import('./components/Pages/signup'));
const ResetPassword = lazy(() => import('./components/Pages/ResetPassword'));
const ForgetPassword = lazy(() => import('./components/Pages/ForgetPassword'));
const OtpConfirm = lazy(() => import('./components/OtpPage'));
const NotFound = lazy(() => import('./components/Pages/NotFound'));
const PaymentSuccessMessage = lazy(() => import('./components/Pages/PaymentSuccessMessage'));
const PaymentFailedMessage = lazy(() => import('./components/Pages/PaymentFailed'));
const Product = lazy(() => import('./components/Pages/Product'));
const Terms_condition = lazy(() => import('./components/Pages/Terms_condition'));
const FreeCalculator = lazy(() => import('./components/Pages/FreeCalculator'));
const BuyNow = lazy(() => import('./components/Pages/Buynow'));

function App() {

  //local
  // ReactGA.initialize([
  //   {
  //     trackingId: "G-K0Z0EKCNEN",
  //   },
  //   {
  //     trackingId: "G-K0Z0EKCNEN",
  //   },
  // ]);

  // All of this used to run in the component body, so it repeated on every
  // render: Google Analytics was re-initialised, a new session start time was
  // written, and - worst - another setInterval was created and never cleared.
  // The timers accumulated for the life of the page, each firing an analytics
  // event every ten seconds, so the longer a session ran the more work the
  // browser did on a fixed schedule. That is felt everywhere, including on the
  // sign-in form.
  //
  // Once, on mount, with the timer cleaned up on unmount.
  useEffect(() => {
    ReactGA.initialize([{ trackingId: "G-65B2EWCMZW" }]);

    const guestId = uuidv4();
    const startTime = Date.now();
    sessionStorage.setItem("startTime", String(startTime));

    const reportGuestTime = () => {
      // Only guests are tracked this way; a signed-in session is measured
      // elsewhere.
      if (localStorage.getItem("user")) {
        return;
      }

      const seconds = (Date.now() - startTime) / 1000;
      const minutes = Math.floor(seconds / 60);
      const remainder = Math.floor(seconds % 60);

      ReactGA.event(`GuestUser ${guestId}`, {
        category: "User_Time_Tracking",
        label: window.location.pathname + window.location.search,
        SpentTime: `${minutes}Min,${remainder}Sec`,
      });
    };

    // Every ten seconds was far more often than this needs to be, and it is
    // pure overhead on every visitor.
    const timer = setInterval(reportGuestTime, 60000);

    return () => clearInterval(timer);
  }, []);



  // Send pageview with a custom path
  // ReactGA.send({ hitType: "pageview", page: "/my-path", title: "Custom Title" });

  // function handleTabCloseEvent(event) {
  //   // event.preventDefault();
  //   // const confirmationMessage = 'You have unsaved changes. Are you sure you want to leave?';
  //   // event.returnValue = confirmationMessage;
  //   ReactGA.event({
  //     category: " ",
  //     action: "",
  //     label: "",
  //     value: "",

  //   });

  // }

  // useEffect(() => {
  //   window.addEventListener('beforeunload', handleTabCloseEvent);


  //   return () => {
  //     window.removeEventListener('beforeunload', handleTabCloseEvent);
  //   };
  // }, []);


  return (
    <div>
      <AuthProvider>
        {/* Inside AuthProvider so it can react to sign-in, and outside Router so
            one subscription state serves every screen including the header. */}
        <SubscriptionProvider>
        <Router>
          <ScrollToTop />
          <Header />
          {/* Every screen is loaded on demand.

              The whole app used to ship as one bundle - 3.1 MB, 822 kB
              gzipped - so opening the home page downloaded and parsed the
              7,700-line calculator, the PDF writer and the spreadsheet writer
              before anything appeared. Each route is now its own chunk, and
              only the one being visited is fetched.

              The fallback is deliberately plain: a spinner that appears for
              120ms and vanishes reads as a flicker, so this holds the layout
              without drawing attention to itself. */}
          <Suspense
            fallback={
              <div style={{ minHeight: "60vh" }} aria-busy="true" />
            }
          >
          <Routes>
            <Route exact path='/' element={<Home />} />
            <Route path='/PaymentSuccess' element={<PaymentSuccessMessage />} />
            <Route path='/PaymentFailed' element={<PaymentFailedMessage />} />
            <Route path='/About' element={<About />} />
            <Route path='/Calculator' element={<Calculator />} />
            <Route path='/FreeCalculator' element={<FreeCalculator />} />
            <Route path='/Project' element={<Product />} />
            <Route path='/Contact' element={<Contact />} />
            <Route path='/Pricing' element={<Pricing />} />
            <Route path='/Signup' element={<Signup />} />
            <Route path='/ForgotPassword' element={<ForgetPassword />} />
            <Route path='/ResetPassword' element={<ResetPassword />} />
            <Route path='/OtpVerification' element={<OtpConfirm />} />
            <Route path='/terms&Condition' element={<Terms_condition />} />
            <Route path='/Buynow' element={<BuyNow />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
          </Suspense>
          <Footer />
        </Router>
        </SubscriptionProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
